module.exports = __webpack_public_path__ + "media/images/icons/twotone/edit-322c2a60714352f54498d9a6b9a0f693.svg";